import { useQuery } from '@tanstack/react-query';
import { superAdminApi } from '../api/superAdminApi';

export function useSuperAdminDashboard() {
  return useQuery({
    queryKey: ['superadmin', 'dashboard'],
    queryFn: () => superAdminApi.getDashboard(),
    staleTime: 60_000,
  });
}